import { User } from '../../user/user.model';
import { RootConfig } from '../core/config.scorecard.model';
import { Scorecard } from '../scorecard-next.model';
import {
    PeriodType,
    PeriodTypeShallow,
    ScorecardDataDto,
    ScorecardDto,
} from '../scorecard.model';

import { HistoryPosition } from './general/history-position.model';

// TODO unify after main scorecard state switches to objects
export type ScorecardHistory = {
    [periodTypeId in PeriodType]?: ScorecardDto[];
};
export interface ScorecardDataset {
    [key: string /* periodType-scorecardId */]: ScorecardDataDto;
}

export interface ScorecardWidgetState {
    pending: {
        reload?: boolean;
        listData?: boolean;
    };

    user?: User; // TODO revise. hold onto the full object for now. decide how to cut it down later

    rootConfig?: RootConfig;
    periodTypes?: PeriodTypeShallow[];
    scorecardHistory: ScorecardHistory;
    scorecardDataset: ScorecardDataset;

    selectedPeriodType?: PeriodTypeShallow; // TODO this might move
    selectedScorecardHistory?: ScorecardDto[];
    selectedScorecard?: Scorecard;

    // TODO replace with json config option
    showScorecardDetail?: boolean;
    yourTeamExpanded?: boolean;
    yourTeamEnabled?: boolean;
    historyPos?: HistoryPosition;

    /** TODO revise. this is temporary means of flushing tabs after auth user has changed */
    authUserId?: number;
}

export const defaultState = (): ScorecardWidgetState => ({
    pending: {},
    scorecardHistory: {},
    scorecardDataset: {},
});
